<template lang="pug">
  section
    AlertBox(ref="errorMsg")
    v-flex(xs12)
      v-alert(v-if="hadResultMessage" type="info" value="true") {{ resultList.resultMessageForExpenses }}
    v-flex(xs12 v-if="isFilterError || (hadWork && !hadResultMessage && !noWorkImportRow)")
      v-card
        v-card-title(class="header-summary")
          div.mr-2(v-show="!hadResultMessage")
            span 件数：{{ workListAllCount }} 件
            span.ml-2 エラー件数：{{ workListErrorCount }} 件
          v-checkbox(v-show="!hadResultMessage" label="エラーのみ表示" :value="isFilterError" v-on:change="toggleFilterError")
          v-btn(v-show="!hadResult && !hadResultMessage && !noWorkImportRow" color="success" @click="commit"
            :disabled="!canImport"
            class="commit-btn" :loading="getLoadingStatus") 取込確定
        v-card-text
          section.table-scroll-x.sticky-container(ref="container")
            table
              thead
                tr
                  th(rowspan=2) 該当行
                  th(rowspan=2 width="65px") 取込対象
                  th(rowspan=2) カードID
                  //th(rowspan=2) 受付番号
                  //th(rowspan=2 width="230px") プラン/ルート(シップメントNo)
                  th(rowspan=1) 1次配送委託先(卸/配車)
                  //th(rowspan=2) 実運送会社名<br/>(卸/配車)
                  //th(rowspan=2) 車両車格<br/>(卸/配車)
                  //th(rowspan=2) 車番(卸/配車)
                  //th(rowspan=2) シャーシ番号<br/>(卸/配車)
                  th(colspan=2) {{ getBillingItemName('BASIC_RATE') }}(請求)
                  th(colspan=2) {{ getBillingItemName('MULTI_DELI') }}(請求)
                  th(colspan=2) {{ getBillingItemName('SPECIAL_COST') }}(請求)
                  th(colspan=2) {{ getBillingItemName('TOLL') }}(請求)
                  th(colspan=2) {{ getBillingItemName('LOADING_PALLET') }}（請求）
                  th(colspan=2) {{ getBillingItemName('UNLOADING_PALLET') }}（請求）
                  th(colspan=2) {{ getBillingItemName('WAITING_COST') }}（請求）
                  th(colspan=2) {{ getBillingItemName('ADDITIONAL_WORK') }}（請求）
                  th(colspan=2) {{ getBillingItemName('OTHER') }}（請求）
                  th(colspan=2) {{ getBillingItemName('SPARE1') }}（請求）
                  th(colspan=2) {{ getBillingItemName('SPARE2') }}（請求）
                  th(colspan=2) {{ getBillingItemName('SPARE3') }}（請求）
                  th(colspan=2) {{ getBillingItemName('SPARE4') }}（請求）
                  th(colspan=2) {{ getBillingItemName('SPARE5') }}（請求）

                  th(colspan=2) {{ getPaymentItemName('BASIC_RATE') }}(支払)
                  th(colspan=2) {{ getPaymentItemName('MULTI_DELI') }}(支払)
                  th(colspan=2) {{ getPaymentItemName('SPECIAL_COST') }}(支払)
                  th(colspan=2) {{ getPaymentItemName('TOLL') }}(支払)
                  th(colspan=2) {{ getPaymentItemName('LOADING_PALLET') }}（支払）
                  th(colspan=2) {{ getPaymentItemName('UNLOADING_PALLET') }}（支払）
                  th(colspan=2) {{ getPaymentItemName('WAITING_COST') }}（支払）
                  th(colspan=2) {{ getPaymentItemName('ADDITIONAL_WORK') }}（支払）
                  th(colspan=2) {{ getPaymentItemName('OTHER') }}（支払）
                  th(colspan=2) {{ getPaymentItemName('SPARE1') }}（支払）
                  th(colspan=2) {{ getPaymentItemName('SPARE2') }}（支払）
                  th(colspan=2) {{ getPaymentItemName('SPARE3') }}（支払）
                  th(colspan=2) {{ getPaymentItemName('SPARE4') }}（支払）
                  th(colspan=2) {{ getPaymentItemName('SPARE5') }}（支払）
                tr
                  //1次委託先
                  th.second-row 現在
                  //th.second-row 入力
                  //基本料金(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //置周料金(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //特費(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //高速代(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //積込料(パレット)(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //取卸料(パレット)(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //待機料(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //附帯作業料(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //その他(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //予備1(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //予備2(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //予備3(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //予備4(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //予備5(請求)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力

                  //基本料金(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //置周料金(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //特費(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //高速代(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //積込料(パレット)(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //取卸料(パレット)(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //待機料(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //附帯作業料(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //その他(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //予備1(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //予備2(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //予備3(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //予備4(支払)
                  th.second-row(width="100px") 現在
                  th.second-row(width="100px") 入力
                  //予備5(支払)
                  th.second-row(width="100px") 現在
                  th.second-row.right-border(width="100px") 入力
              tbody
                template(v-if="workList.length")
                  tr(v-for="(orderRec,index) in workList")
                    // 該当行
                    td.text-md-center {{ orderRec.lineNo }}

                    // 取込対象
                    td.text-md-center.targetSelectCell(v-if="!hadResultMessage && !isValidError(orderRec)")
                      template(v-if="orderRec.anyBillingPriceDifference || orderRec.anyPaymentPriceDifference")
                        v-checkbox.justify-center.align-center(v-model="orderRec.importTarget")
                        template(v-if="validStatus(orderRec) !== ''")
                          div
                            v-tooltip(top)
                              template(v-slot:activator="{ on }")
                                v-icon(v-on="on").warning-box-icon warning
                              span.whitespace-pre {{ validStatus(orderRec) }}
                      template(v-else)
                        span 変更無し
                    td.text-md-center(v-else-if="isValidError(orderRec)")
                      // エラーがある場合
                      ImportErrorMessageBlock(:validationErrorList="orderRec.validationErrorList")
                    td(v-else)
                    // カードID
                    td.text-md-center {{ orderRec.cardId }}
                    //td.text-md-left {{ orderRec.receiptNo }}
                    //td.text-md-left {{ getDisplayKey(orderRec) }}
                    // 1次配送委託先(卸/配車)
                    td.text-md-left {{ getDispDeliveryCompanyCard(orderRec) }}
                    // 実運送会社名(卸/配車)
                    //td.text-md-left(:class="{ updateCell : orderRec.isPrimaryDeliveryCompanyDiff}") {{ getDispDeliveryCompany(orderRec) }}
                    //td.text-md-left {{ orderRec.deliveryCompanyName }}
                    //td.text-md-left {{ orderRec.vehicleType }}
                    //td.text-md-left {{ orderRec.vehicleNo }}
                    //td.text-md-left {{ orderRec.chassisNo }}
                    //基本料金(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingBasicPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingBasicPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingBasicPrice")
                    //置周料金(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingMultiDeliveryPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingMultiDeliveryPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingMultiDeliveryPrice")
                    //特費(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpecialCostPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingSpecialCostPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingSpecialCostPrice")
                    //高速代(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingTollPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingTollPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingTollPrice")
                    //積込料(パレット)(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingLoadingPalletPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingLoadingPalletPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingLoadingPalletPrice")
                    //取卸料(パレット)(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingUnloadingPalletPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingUnloadingPalletPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingUnloadingPalletPrice")
                    //待機料(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingWaitingCostPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingWaitingCostPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingWaitingCostPrice")
                    //附帯作業料(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingAdditionalWorkPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingAdditionalWorkPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingAdditionalWorkPrice")
                    //その他(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingOtherPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingOtherPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingOtherPrice")
                    //予備1(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpare1PriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingSpare1PriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingSpare1Price")
                    //予備2(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpare2PriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingSpare2PriceDifference }")
                      DigitSeparatorsLabel(:value="orderRec.billingSpare2Price")
                    //予備3(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpare3PriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingSpare3PriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.billingSpare3Price")
                    //予備4(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpare4PriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingSpare4PriceDifference }")
                      DigitSeparatorsLabel(:value="orderRec.billingSpare4Price")
                    //予備5(請求)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpare5PriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.billingSpare5PriceDifference }")
                      DigitSeparatorsLabel(:value="orderRec.billingSpare5Price")


                    //基本料金(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentBasicPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentBasicPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentBasicPrice")
                    //置周料金(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentMultiDeliveryPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentMultiDeliveryPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentMultiDeliveryPrice")
                    //特費(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentSpecialCostPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentSpecialCostPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentSpecialCostPrice")
                    //高速代(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentTollPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentTollPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentTollPrice")
                    //積込料(パレット)(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentLoadingPalletPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentLoadingPalletPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentLoadingPalletPrice")
                    //取卸料(パレット)(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentUnloadingPalletPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentUnloadingPalletPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentUnloadingPalletPrice")
                    //待機料(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentWaitingCostPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentWaitingCostPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentWaitingCostPrice")
                    //附帯作業料(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentAdditionalWorkPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentAdditionalWorkPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentAdditionalWorkPrice")
                    //その他(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentOtherPriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentOtherPriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentOtherPrice")
                    //予備1(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentSpare1PriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentSpare1PriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentSpare1Price")
                    //予備2(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentSpare2PriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentSpare2PriceDifference }")
                      DigitSeparatorsLabel(:value="orderRec.paymentSpare2Price")
                    //予備3(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentSpare3PriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentSpare3PriceDifference}")
                      DigitSeparatorsLabel(:value="orderRec.paymentSpare3Price")
                    //予備4(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentSpare4PriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentSpare4PriceDifference }")
                      DigitSeparatorsLabel(:value="orderRec.paymentSpare4Price")
                    //予備5(支払)
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.paymentSpare5PriceCurrent")
                    td.text-xs-right(:class="{ updateCell : orderRec.paymentSpare5PriceDifference }")
                      DigitSeparatorsLabel(:value="orderRec.paymentSpare5Price")



                template(v-else)
                  tr
                    td(:colspan="15") {{ this.$config.messages.Common.Warn.SearchResultNotFound }}

    v-flex(xs12 v-if="hadResultError")
      v-card
        v-card-text
          section
            table(class="order-table")
              thead
                tr
                  th(width="65px") 該当行
                  th エラー内容
              tbody
                tr(v-for="(data,index) in resultList.errorList")
                  td.text-md-center {{ data.lineNo }}
                  td.text-md-center
                    div.text-xs-left
                      span {{ data.message }}
                      // エラーがある場合
                      ImportErrorMessageBlock(:validationError="data.fieldErrors")
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { LabelName } from "@/assets/js/constants";
import AlertBox from "@/components/common/AlertBox";
import BillingStatusTypeHandler from "@/mixin/BillingStatusTypeHandler";
import PaymentStatusTypeHandler from "@/mixin/PaymentStatusTypeHandler";
import DigitSeparatorsLabel from "@/components/common/DigitSeparatorsLabel";
import DispatchVehicleSelect from "@/components/dispatch/DispatchVehicleSelect.vue";
import ImportErrorMessageBlock from "@/components/common/error/ImportErrorMessageBlock.vue";

export default {
  components: {
    ImportErrorMessageBlock,
    DispatchVehicleSelect,
    AlertBox,
    DigitSeparatorsLabel
  },
  data() {
    return {
      labelName: LabelName
    };
  },
  mixins: [BillingStatusTypeHandler, PaymentStatusTypeHandler],
  computed: {
    ...mapGetters("finance", {
      workListAllCount: "workListAllCount",
      workListErrorCount: "workListErrorCount",
      noWorkImportRow: "noWorkImportRow",
      isFilterError: "errorOnly",
      isFilterNoError: "noErrorOnly",
      canImport: "canImport"
    }),
    ...mapGetters("indicator", {
      getLoadingStatus: "getLoadingStatus"
    }),
    workList: {
      get() {
        return this.$store.state.finance.workList;
      }
    },
    resultList: {
      get() {
        return this.$store.state.finance.workResultList;
      }
    },
    hadWork: {
      get() {
        return !(!this.workList || this.workList.length < 1);
      }
    },
    hadResult: {
      get() {
        return !(!this.resultList || this.resultList.length < 1);
      }
    },
    hadResultError: {
      get() {
        if (!this.hadResult) return false;
        return !(!this.resultList.errorList || this.resultList.errorList.length < 1);
      }
    },
    hadResultMessage: {
      get() {
        if (!this.hadResult) return false;
        return (
          this.resultList.resultMessageForExpenses !== undefined &&
          this.resultList.resultMessageForExpenses !== ""
        );
      }
    },
    isValidError: function () {
      return function (orderRec) {
        return Object.keys(orderRec.validationError).length;
      };
    },
    // 項目名称の動的取得
    getBillingItemName: function () {
      return function (controlCd) {
        if (this.workList.length > 0 && this.workList[0].billingItemNames) {
          return this.workList[0].billingItemNames[controlCd] || controlCd;
        }
        return controlCd;
      };
    },
    getPaymentItemName: function () {
      return function (controlCd) {
        if (this.workList.length > 0 && this.workList[0].paymentItemNames) {
          return this.workList[0].paymentItemNames[controlCd] || controlCd;
        }
        return controlCd;
      };
    }
  },
  methods: {
    /** Action：Vuex */
    ...mapActions("finance", {
      fetchClearWorkList: "fetchClearWorkList",
      toggleExpensesImportErrorOnly: "toggleExpensesImportErrorOnly"
    }),
    toggleFilterError() {
      this.toggleExpensesImportErrorOnly(!this.isFilterError);
      this.pageCount = 0;
      this.loadWorkData();
    },
    loadWorkDataAll() {
      this.toggleExpensesImportErrorOnly(false);
      this.loadWorkData();
    },
    loadWorkData() {
      this.$refs.errorMsg.nonDisplayMessage();
      const getParams = {
        pageCount: this.pageCount
      };
      if (!this.hadResult) {
        this.$store.dispatch("finance/fetchAllExpensesImportWork", getParams).then(() => {
          if (this.$store.state.finance.noWorkImportRow) {
            if (!this.isFilterError) {
              this.$refs.errorMsg.displayMessage("金額が登録されている行がありません。");
            }
          }
        });
      }
    },
    fetchWorkListCount() {
      this.$store.dispatch("finance/fetchExpensesImportWorkCount");
    },
    clearWorkData() {
      this.pageCount = 0;
      this.fetchClearWorkList();
    },
    commit() {
      this.toggleExpensesImportErrorOnly(false);

      // 取込対象外のカードID
      const cardIdList = this.workList
        .filter(rec => {
          return rec.importTarget === true;
        })
        .map(value => value.cardId);

      this.$store.dispatch("finance/commitImportRequest", cardIdList);
    },
    displayValidate(value) {
      let list = [];
      Object.entries(value).forEach(value => {
        list.push(value[0] + " : " + value[1]);
      });
      return list.join("\n");
    },
    getDisplayKey(data) {
      let key = "";
      if (data.planNo && data.routeNo && data.routeNoSeq) {
        key = data.planNo + "/" + data.routeNo + "-" + data.routeNoSeq;
        if (data.shipmentNo) {
          key = key + "(" + data.shipmentNo + ")";
        }
      }
      return key;
    },
    getDispDeliveryCompanyCard(detail) {
      if (detail.cardPrimaryDeliveryCompanyName && detail.cardPrimaryDeliveryCompanyCd) {
        return detail.cardPrimaryDeliveryCompanyName + "/" + detail.cardPrimaryDeliveryCompanyCd;
      } else if (detail.cardPrimaryDeliveryCompanyName) {
        return detail.cardPrimaryDeliveryCompanyName;
      } else {
        return detail.cardPrimaryDeliveryCompanyCd;
      }
    },
    getDispDeliveryCompany(detail) {
      if (detail.primaryDeliveryCompanyName && detail.primaryDeliveryCompanyCd) {
        return detail.primaryDeliveryCompanyName + "/" + detail.primaryDeliveryCompanyCd;
      } else if (detail.primaryDeliveryCompanyName) {
        return detail.primaryDeliveryCompanyName;
      } else {
        return detail.primaryDeliveryCompanyCd;
      }
    },
    validStatus(data) {
      let message = "";
      if (data.billingTollPrice && this.isTemp(data.billingStatus)) {
        message = "請求状態が仮確定です。 ";
      }
      if (data.paymentTollPrice && this.isTemp(data.paymentStatus)) {
        message = message + "支払状態が仮確定です。";
      }

      if (message !== "") {
        message += "取込を行うと、状態が未確定に変更されます。";
      }

      return message;
    }
  },
  mounted() {
    this.clearWorkData();
    this.loadWorkData();
  }
};
</script>

<style lang="stylus" scoped>
.header-summary {
  display: flex;
  justify-content: flex-end;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  table-layout: auto;

  td {
    height: 48px;
    border: solid #dcdcdc;
    border-width: 1px 0;
    vertical-align: middle;
    padding-left: 8px;
    padding-right: 8px;
  }

  thead {
    position: sticky;
    top: 0;
    height: 54px;
    z-index: 1;

    tr {
      height: 54px;
    }

    th {
      border-right: 1px solid #E0E0E0;
      background-color: #fff;
      padding: 8px;
    }
  }

  th:last-child, td:last-child {
    border-right: none;
  }

  .no-right-border {
    border-right: none;
  }

  th:last-child.right-border {
    border-right: 1px solid #E0E0E0;
  }

  tbody {
    tr {
      transition: 0.3s;
    }

    td {
      border-right: 1px solid #E0E0E0;
    }

    td.updateCell {
      background-color: #A5D6A7 // green lighten-3
    }
  }
}

.order-table {
  border-collapse: separate;
  border-spacing: 0;

  td {
    border-bottom: none;
  }
}

.commit-btn {
  margin: 0 8px 0 40px;
}

.warning-box-icon {
  color: #FF5722;
}

.targetSelectCell {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
